import * as Yup from "yup";

export const systemSettingFormInitialValues = (bulk: boolean = false) => ({
  volume: 4,
  speed_unit: "mph",
  parking_photo: "ALL",
  audio_alert: "en-US",
  driver_id_login_audio_hint: !bulk, //true
  live_view_audio_hint: false,
  driver_id_mode: "normal",
  record_sound_in_cab: false,
  video_snapshots: true,
  vr_K145_embedded_videoFormat: "Separate",
  vr_K245_embedded_videoFormat: "Side-By-Side",
  vr_K220_embedded_videoFormat: "Side-By-Side",
  vr_K165_embedded_videoFormat: "Separate",
  vr_K265_embedded_videoFormat: "Side-By-Side",
});

export const sensorEventDetectionFormInitialValues = (
  bulk: boolean = false
) => ({
  impact_enable: !bulk, // true,
  harsh_enable: !bulk, // true,
  driving_impact: 0,
  parking_impact: 0,
  impact_pre_event_video_duration_sec: 15,
  impact_post_event_video_duration_sec: 15,
  impact_in_cabin_audio_alert: !bulk, // true,
  harsh_acceleration_sensitivity: 0,
  harsh_braking_sensitivity: 0,
  harsh_cornering_sensitivity: 0,
  harsh_acceleration_speed: 0,
  harsh_braking_speed: 11,
  harsh_cornering_speed: 30,
  harsh_pre_event_video_duration_sec: 10,
  harsh_post_event_video_duration_sec: 3,
  harsh_in_cabin_audio_alert: !bulk, // true,
});

export const aiEventDetectionFormInitialValues = (bulk: boolean = false) => ({
  // adas side
  adasEnable: !bulk, // true,
  adas_frontalEnable: !bulk, // true,
  adas_pedestrianCollisionEnable: !bulk, // true,
  adas_tailgatingEnable: !bulk, // true,
  adas_laneEnable: !bulk, // true,
  adas_stopandgoEnable: !bulk, // true,

  //dms side
  dmsEnable: !bulk, // true,
  dms_fatigueEnable: !bulk, // true,
  dms_seatbeltUnfastenEnable: !bulk, // true,
  dms_distractionEnable: !bulk, // true,
  dms_phoneEnable: !bulk, // true,
  dms_lensCoveredEnable: !bulk,
  dms_smokingEnable: !bulk,

  //adas -frontal
  frontal_sensitive: 0,
  frontal_videoBefore: 5,
  frontal_videoAfter: 5,
  frontal_eventDebounce: 30,
  frontal_audioAlert: !bulk, // true,

  //adas - pedestrian
  pedestrianCollision_sensitive: 0,
  pedestrianCollision_videoBefore: 5,
  pedestrianCollision_videoAfter: 5,
  pedestrianCollision_eventDebounce: 30,
  pedestrianCollision_audioAlert: false,

  //adas - tailgating
  tailgating_sensitive: 0,
  tailgating_videoBefore: 15,
  tailgating_videoAfter: 5,
  tailgating_eventDebounce: 30,
  tailgating_audioAlert: !bulk, // true,

  //adas - lane
  lane_sensitive: 0,
  lane_videoBefore: 5,
  lane_videoAfter: 5,
  lane_eventDebounce: 30,
  lane_audioAlert: !bulk, // true,

  //adas - stopandgo
  stopandgo_sensitive: 0,
  stopandgo_videoBefore: 5,
  stopandgo_videoAfter: 5,
  stopandgo_eventDebounce: 30,
  stopandgo_audioAlert: !bulk, // true,

  //dms - fatigue
  fatigue_sensitive: 0,
  fatigue_videoBefore: 10,
  fatigue_videoAfter: 5,
  fatigue_eventDebounce: 30,
  fatigue_audioAlert: !bulk, // true,

  //dms - distracted
  distraction_sensitive: 0,
  distraction_videoBefore: 10,
  distraction_videoAfter: 5,
  distraction_eventDebounce: 30,
  distraction_audioAlert: !bulk, // true,

  //dms - phone
  phone_sensitive: 0,
  phone_videoBefore: 5,
  phone_videoAfter: 5,
  phone_eventDebounce: 30,
  phone_audioAlert: !bulk, // true,

  //dms - seatbelt
  seatbeltUnfasten_sensitive: 0,
  seatbeltUnfasten_videoBefore: 5,
  seatbeltUnfasten_videoAfter: 5,
  seatbeltUnfasten_eventDebounce: 30,
  seatbeltUnfasten_audioAlert: !bulk, // true,

  //dms - lens obstruction
  lensCovered_sensitive: 0,
  lensCovered_videoBefore: 5,
  lensCovered_videoAfter: 5,
  lensCovered_eventDebounce: 30,
  lensCovered_audioAlert: !bulk, // true,

  //dms - smoking detection
  smoking_sensitive: 0,
  smoking_videoBefore: 5,
  smoking_videoAfter: 5,
  smoking_eventDebounce: 30,
  smoking_audioAlert: !bulk, // true,
});

export const trafficSignalDetectionFormInitialValues = (
  bulk: boolean = false
) => ({
  truckModeEnable: !bulk, // true, // under speeding payload
  mmfOverSpeed_audioAlert: "severe",
  speedingEnable: false,

  // Left Menu
  speedCamEnable: !bulk, // true,
  rollingStopEnable: !bulk, // true,
  railroadCrossEnable: !bulk, // true, // Deprectaed in VM
  schoolZoneSpeedingEnable: !bulk, // true, // Deprectaed in VM

  // Speed Cam
  speedCam_speed: 25,
  speedCam_videoBefore: 5,
  speedCam_videoAfter: 5,
  speedCam_audioAlert: !bulk, // true,
  speedCam_severeMedia: "video",

  // rolling speed
  rollingStop_videoBefore: 10,
  rollingStop_videoAfter: 5,
  rollingStop_audioPreWarning: false,
  rollingStop_audioAlert: !bulk, // true,
  rollingStop_media: "video",

  //railroad crossing
  railroadCross_audioPreWarning: true,

  //school zone speed violation
  schoolZoneSpeeding_audioPreWarning: true,
});

const videoBeforeSchema = Yup.number()
  .min(4, "Must be at least 4 seconds")
  .max(15, "Must be at most 15 seconds")
  .required("Please enter a numeric value");

const videoAfterSchema = Yup.number()
  .min(0, "Must be at least 0 seconds")
  .max(30, "Must be at most 30 seconds")
  .required("Please enter a numeric value");

const eventDebounceSchema = Yup.number()
  .min(30, "Must be at least 30 seconds")
  .max(604800, "Must be at most 604800 seconds")
  .required("Please enter a numeric value");

export const aiEventDetectionFormValidationSchema = Yup.object().shape({
  // ADAS - Frontal
  frontal_videoBefore: videoBeforeSchema,
  frontal_videoAfter: videoAfterSchema,
  frontal_eventDebounce: eventDebounceSchema,

  // ADAS - Pedestrian Collision
  pedestrianCollision_videoBefore: videoBeforeSchema,
  pedestrianCollision_videoAfter: videoAfterSchema,
  pedestrianCollision_eventDebounce: eventDebounceSchema,

  // ADAS - Tailgating
  tailgating_videoBefore: videoBeforeSchema,
  tailgating_videoAfter: videoAfterSchema,
  tailgating_eventDebounce: eventDebounceSchema,

  // ADAS - Lane
  lane_videoBefore: videoBeforeSchema,
  lane_videoAfter: videoAfterSchema,
  lane_eventDebounce: eventDebounceSchema,

  // ADAS - Stop & Go
  stopandgo_videoBefore: videoBeforeSchema,
  stopandgo_videoAfter: videoAfterSchema,
  stopandgo_eventDebounce: eventDebounceSchema,

  // DMS - Fatigue
  fatigue_videoBefore: videoBeforeSchema,
  fatigue_videoAfter: videoAfterSchema,
  fatigue_eventDebounce: eventDebounceSchema,

  // DMS - Distraction
  distraction_videoBefore: videoBeforeSchema,
  distraction_videoAfter: videoAfterSchema,
  distraction_eventDebounce: eventDebounceSchema,

  // DMS - Phone
  phone_videoBefore: videoBeforeSchema,
  phone_videoAfter: videoAfterSchema,
  phone_eventDebounce: eventDebounceSchema,

  // DMS - Seatbelt Unfasten
  seatbeltUnfasten_videoBefore: videoBeforeSchema,
  seatbeltUnfasten_videoAfter: videoAfterSchema,
  seatbeltUnfasten_eventDebounce: eventDebounceSchema,

  // Mass config (ADAS)
  mass_adas_videoBefore: videoBeforeSchema.notRequired(),
  mass_adas_videoAfter: videoAfterSchema.notRequired(),
  mass_adas_eventDebounce: eventDebounceSchema.notRequired(),

  // Mass config (DMS)
  mass_dms_videoBefore: videoBeforeSchema.notRequired(),
  mass_dms_videoAfter: videoAfterSchema.notRequired(),
  mass_dms_eventDebounce: eventDebounceSchema.notRequired(),
});

export const trafficSignalDetectionFormValidationSchema = Yup.object().shape({
  // Speed Cam
  speedCam_videoBefore: videoBeforeSchema,
  speedCam_videoAfter: videoAfterSchema,

  // Rolling Stop
  rollingStop_videoBefore: videoBeforeSchema,
  rollingStop_videoAfter: videoAfterSchema,
});
